var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEm5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Very Confident"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.0001 22C44.0001 34.1501 34.1813 44 22.0695 44C9.95776 44 0.138916 34.1501 0.138916 22C0.138916 9.84991 9.95776 0 22.0695 0C34.1813 0 44.0001 9.84991 44.0001 22Z",
    fill: "#DAE7F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66218 22.0862C4.35348 9.93469 9.81021 3.66219 19.1638 0.172913C8.35793 1.5378 0 10.7891 0 21.9995C0 34.1496 9.81885 43.9995 21.9306 43.9995C23.9542 43.9995 25.913 43.7231 27.7733 43.2087C26.8674 43.3229 25.9427 43.4298 25.007 43.3821C14.976 42.8701 4.97088 34.2325 4.66218 22.0862Z",
    fill: "#B5C4D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4148 19.6965C13.4148 17.6174 12.1219 15.9318 10.5275 15.9318C8.93266 15.9318 7.63977 17.6174 7.63977 19.6965C7.63977 21.7756 8.93266 23.4613 10.5275 23.4613C12.1224 23.4613 13.4148 21.7756 13.4148 19.6965Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.8014 19.6965C35.8014 17.6174 34.5085 15.9318 32.9141 15.9318C31.3193 15.9318 30.0264 17.6174 30.0264 19.6965C30.0264 21.7756 31.3193 23.4613 32.9141 23.4613C34.509 23.4613 35.8014 21.7756 35.8014 19.6965Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.67774 14.2305C7.67774 14.2305 8.41468 14.0335 9.48337 13.8211C10.9265 13.5336 12.9751 13.2182 14.6256 13.3217C17.4985 13.5018 15.4418 10.4942 10.4868 11.5922C5.53269 12.6908 6.39782 14.5315 7.67774 14.2305Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.0103 14.2305C35.0103 14.2305 34.2734 14.0335 33.2047 13.8211C31.7616 13.5336 29.713 13.2182 28.0625 13.3217C25.1896 13.5018 27.2463 10.4942 32.2013 11.5922C37.1559 12.6903 36.2903 14.5315 35.0103 14.2305Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.3007 27.2745C30.3007 31.9442 26.5272 35.7296 21.8722 35.7296C17.2167 35.7296 13.4427 31.9442 13.4427 27.2745C13.4427 22.6048 17.2163 26.7192 21.8722 26.7192C26.5267 26.7192 30.3007 22.6048 30.3007 27.2745Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8977 33.2372C16.1387 32.4457 17.289 29.6076 21.434 29.4006C24.8829 29.2282 26.8528 30.0026 27.1379 32.6515C27.1762 33.0068 27.1742 33.4244 27.1322 33.8795C25.6905 35.0361 23.8619 35.7277 21.8722 35.7277C19.5374 35.7277 17.4242 34.7755 15.8977 33.2372Z",
    fill: "#F2F8FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEm5);
export default __webpack_public_path__ + "static/media/em5.8678c8106d02ee3379cd976463adba53.svg";
export { ForwardRef as ReactComponent };